module.exports = "\n<div class=\"accordion\" v-bind:class=\"open === true ? 'open' : 'closed' \">\n <div @click=\"open = !open\" class=\"accordion_head\">\n   <span>{{ title }}</span>\n </div>\n <div class=\"accordion_body\" v-bind:class=\"open === true ? 'open' : 'closed' \">\n   <slot></slot>\n </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccordionTab.vue
 ** module id = 18
 ** module chunks = 1
 **/